<template>
  <div>
    <!-- DAU -->
    <Echart
      :options="options"
      id="bottomLeftChart"
      height="480px"
      width="100%"
    ></Echart>
  </div>
</template>

<script>
import Echart from "@/common/echart";
export default {
  data() {
    return {
      options: {},
    };
  },
  components: {
    Echart,
  },
  props: {
    cdata: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {},

  methods: {
    formatter(params) {
      let values1 = this.cdata.counts[0].c;
      let values2 = this.cdata.counts[1].c;
      let values3 = this.cdata.counts[2].c;
      let texts = `${params[0].name}`;
      if (params[0]) {
        let vs = 0;
        if (params[0].seriesName == "普通用户") {
          vs = this.cdata.counts[0].c;
        } else if (params[0].seriesName == "医生") {
          vs = this.cdata.counts[1].c;
        }
        // else if (params[0].seriesName == "心理医生") {
        //   vs = this.cdata.counts[2].c
        // }
        texts =
          texts +
          `<br />${params[0] ? params[0].seriesName : ""}: ${
            params[0] ? params[0].value : ""
          }`;
        if (params[0].seriesName != "总和") {
          texts =
            texts +
            ` (${
              vs > 0
                ? (((params[0] ? params[0].value : 0) / vs) * 100).toFixed(1)
                : 0
            }%)`;
        }
      }
      if (params[1]) {
        let vs = 0;
        if (params[1].seriesName == "普通用户") {
          vs = this.cdata.counts[0].c;
        } else if (params[1].seriesName == "医生") {
          vs = this.cdata.counts[1].c;
        }
        // else if (params[0].seriesName == "心理医生") {
        //   vs = this.cdata.counts[2].c
        // }
        texts =
          texts +
          `<br />${params[1] ? params[1].seriesName : ""}: ${
            params[1] ? params[1].value : ""
          }`;
        if (params[1].seriesName != "总和") {
          texts =
            texts +
            ` (${
              vs > 0
                ? (((params[1] ? params[1].value : 0) / vs) * 100).toFixed(1)
                : 0
            }%)`;
        }
      }
      if (params[2]) {
        texts =
          texts +
          `<br />${params[2] ? params[2].seriesName : ""}: ${
            params[2] ? params[2].value : ""
          } `;
        if (params[2].seriesName != "总和") {
          texts =
            texts +
            ` (${
              values3 > 0
                ? (((params[2] ? params[2].value : 0) / values3) * 100).toFixed(
                    1
                  )
                : 0
            }%)`;
        }
      }
      if (params[3]) {
        texts =
          texts +
          `<br />${params[3] ? params[3].seriesName : ""}: ${
            params[3] ? params[3].value : ""
          } `;
      }
      return texts;
      //   `${params[0].name}
      // <br />${params[0]?params[0].seriesName:''}: ${params[0]?params[0].value:''} (${values1>0?(params[0]?params[0].value:0/values1*100).toFixed(1):0}%)
      // <br />${params[1]?params[1].seriesName:''}: ${params[1]?params[1].value:''} (${values2>0?(params[1]?params[1].value:0/values2*100).toFixed(1):0}%)
      // <br />${params[2]?params[2].seriesName:''}: ${params[2]?params[2].value:''} (${values3>0?(params[2]?params[2].value:0/values3*100).toFixed(1):0}%)
      // <br />${params[3]?params[3].seriesName:''}: ${params[3]?params[3].value:''} `
    },
  },
  watch: {
    cdata: {
      handler(newData) {
        this.options = {
          tooltip: {
            trigger: "axis",
            formatter: this.formatter,
            axisPointer: {
              type: "cross",
              crossStyle: {
                color: "#999",
              },
            },
          },
          toolbox: {
            feature: {
              dataView: {
                show: true,
                readOnly: false,
              },
              magicType: {
                show: true,
                type: ["line", "bar"],
              },
              restore: {
                show: true,
              },
              saveAsImage: {
                show: true,
              },
            },
          },
          legend: {
            data: ["普通用户", "医生", "总和"],
          },
          xAxis: [
            {
              type: "category",
              data: newData.times,
              axisPointer: {
                type: "shadow",
              },
            },
          ],
          yAxis: [
            {
              type: "value",
              name: "Precipitation",
              min: 0,
              // max: 250,
              interval: 50,
              axisLabel: {
                formatter: "{value} ",
              },
            },
          ],
          series: newData.list,
        };
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>